import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import CheckIcon from '@material-ui/icons/Check';
import SaveIcon from '@material-ui/icons/Save';
import InputAdornment from '@material-ui/core/InputAdornment';
import Grid from '@material-ui/core/Grid';
import SearchIcon from '@material-ui/icons/Search';
import Alert from '@material-ui/lab/Alert';
import Collapse from '@material-ui/core/Collapse';
import Snackbar from '@material-ui/core/Snackbar';
import CircularProgress from '@material-ui/core/CircularProgress';
import Modal from '@material-ui/core/Modal';
import Switch from '@material-ui/core/Switch';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { mask } from 'remask';
import moment from 'moment';
import 'moment/locale/pt-br';
import { instanceAxios } from '../../InstanceAxios';
import environment from '../../environment';
import { XMEI_PRIMARY_COLOR } from '../../consts/common';
import HeadTable from '../../components/HeadTable';
import Pessoal from './pessoal';
import Endereco from './endereco';
import Empresa from './empresa';
import NotaFiscal from './notafiscal';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import FilterIcon from '@material-ui/icons/FilterList';

const useStyles = (theme) => ({
  root: {
    width: '95%',
  },
  container: {
    height: '100vh',
  },
  button: {
    margin: theme.spacing(1),
    active: { color: 'red' },
  },
  selectTipo: {
    width: 200,
  },
  paper: {
    position: 'absolute',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    top: `50%`,
    left: `50%`,
    transform: `translate(-50%, -50%)`,
    width: '80%',
    height: '80%',
    overflow: 'auto',
    loading: {
      marginLeft: '50%',
    },
  },
});

class ClientesComponent extends Component {
  constructor() {
    super();
    this.axios = instanceAxios(localStorage.getItem('toobiauth'));
    moment.locale('pt-br');
  }

  state = {
    clientes: [],
    originalClientes: [],
    filterText: '', // Filter text
    isModalOpen: false, // Modal open state
    modalPosition: { top: 0, left: 0 }, // Position of the modal
    modalColumnId: null,
    orderBy: '', // Coluna pela qual estamos ordenando
    tipoEmpresa: [],
    columns: [
      { id: 'nome', label: 'Nome', minWidth: 140, filterable: true },
      { id: 'cpf', label: 'CPF', minWidth: 140, filterable: true },
      {
        id: `"UsuarioEmpresa->Empresa"."cnpj"`,
        label: 'CNPJ',
        minWidth: 180,
        filterable: true,
      },
      {
        id: `"EnderecoUsuario"."cidade"`,
        label: 'Cidade',
        minWidth: 140,
        filterable: true,
      },
      {
        id: `"EnderecoUsuario"."estado"`,
        label: 'Estado',
        minWidth: 60,
        filterable: true,
      },
      { id: 'email', label: 'Email', minWidth: 140, filterable: true },
      { id: 'telefone', label: 'Telefone', minWidth: 140, filterable: true },
      { id: 'editar', label: '', minWidth: 140, filterable: false },
    ],
    busca: '',
    cliente: this.cleanCliente(),
    abaModal: 'PESSOAL',
    openAlert: false,
    openModal: false,
    ready: false,
    limit: 10,
    offset: 0,
    count: 0,
    order: 'asc',
    idOrder: '',
    assinantes: false,
    textoSwitch: 'Todos Clientes',
    dadosObrigatorioMunicipio: null,
    empresaEnotas: null,
    isValidPessoal: true,
    isValidEmpresa: true,
    isValidEndreco: true,
    updateNfe: false,
    updateUser: false,
    updateEndereco: false,
    updateEmpresa: false,
    isValidButton: true,
    msgAlert: '',
    tipoAlert: '',
    cupom: null,
  };

  setIdOrder = (idOrder) => {
    // Checando se Não é a coluna Editar
    if (idOrder === 'editar') return;

    let order;
    // Checando se é o mesmo atual
    if (idOrder === this.state.idOrder) {
      order = this.state.order === 'asc' ? 'desc' : 'asc';
      this.setState({ order });
    } else {
      order = 'asc';
      this.setState({ order, idOrder });
    }
    this.atualizarClientes(
      this.state.busca,
      this.state.limit,
      this.state.offset,
      this.state.assinantes,
      idOrder,
      order
    );
  };

  cleanCliente() {
    return {
      cpf: '',
      rg: '',
      telefone: '',
      perfil: 'COMUM',
      EnderecoUsuario: this.cleanEnderecoUsuario(),
      UsuarioEmpresa: this.cleanUsuarioEmpresa(),
    };
  }

  cleanEnderecoUsuario() {
    return {
      cep: '',
    };
  }

  cleanUsuarioEmpresa() {
    return {
      Empresa: {
        cnpj: '',
        cep: '',
        EmpresaUsuarioNFE: {},
      },
    };
  }

  componentWillMount() {
    this.atualizarClientes('', 10, 0, false, '', '');
  }

  atualizarClientes = async (
    nome,
    limit,
    offset,
    assinantes,
    idOrder,
    order
  ) => {
    this.axios
      .get(
        `${environment}/clientes?nome=${nome}&limit=${limit}&offset=${offset}&assinantes=${assinantes}&campoOrdenacao=${idOrder}&ordem=${order}`
      )
      .then((res) => {
        this.setState({ clientes: [] });
        const clientes = res.data.rows;

        const { count } = res.data;
        this.setState({ clientes });
        this.setState({ originalClientes: clientes });
        this.setState({ count });
        this.setState({ ready: true });
      })
      .catch((err) => {
        this.handleAlert(true, 'error', 'Erro ao atualizar clientes!');
      });
  };

  handleBusca = async (event) => {
    this.setState({ ready: false });
    this.setState({ busca: event.target.value });
    this.setState({ offset: 0 });
    this.setState({ limit: 10 });
    this.atualizarClientes(
      event.target.value,
      10,
      0,
      this.state.assinantes,
      this.state.idOrder,
      this.state.order
    );
  };

  handleAssinantes = () => {
    const assinantes = !this.state.assinantes;
    const textoSwitch = assinantes ? 'Apenas Assinantes' : 'Todos Clientes';
    this.setState({ offset: 0 });
    this.setState({ limit: 10 });
    this.setState({ assinantes, textoSwitch });
    this.atualizarClientes(
      this.state.busca,
      10,
      0,
      assinantes,
      this.state.idOrder,
      this.state.order
    );
  };

  clickAlert = () => {
    this.setState({ openAlert: false });
  };

  cleanCupom = () => {
    this.setState({ cupom: null });
  };

  handleChangePage = async (event, newPage) => {
    this.setState({ offset: newPage });
    this.atualizarClientes(
      this.state.busca,
      this.state.limit,
      newPage,
      this.state.assinantes,
      this.state.idOrder,
      this.state.order
    );
  };

  handleChangeRowsPerPage = async (event) => {
    this.setState({ limit: event.target.value });
    this.setState({ offset: 0 });
    this.atualizarClientes(
      this.state.busca,
      event.target.value,
      0,
      this.state.assinantes,
      this.state.idOrder,
      this.state.order
    );
  };

  handleAlert = (openAlert, tipoAlert, msgAlert) => {
    this.setState({ openAlert });
    this.setState({ tipoAlert });
    this.setState({ msgAlert });
  };

  handleAtivarDesativar = async () => {
    this.handleAlert(
      true,
      'warning',
      'Aguarde! Não atualize a pagina até salvar os dados!'
    );

    await this.axios
      .get(`${environment}/cliente/ativar/${this.state.cliente.id}`)
      .then((resp) => {
        this.atualizarClientes('', 10, 0, false);
        this.handleAlert(true, 'success', 'Cliente Ativado!');
      })
      .catch((err) => {
        this.handleAlert(true, 'error', 'Erro ao ativar cliente!');
      });
  };

  updateDadosObrigatorios = async (ibge) => {
    await this.axios
      .get(`${environment}/dadosObrigatorioMunicipio/${ibge}`)
      .then((resp) => {
        this.setState({ dadosObrigatorioMunicipio: resp.data });
      })
      .catch((err) => {
        this.setState({ dadosObrigatorioMunicipio: null });
      });
  };

  buscarEmpresaEnotas = async (cnpj) => {
    return await this.axios
      .get(`${environment}/buscarEmpresaENotasPorCNPJ/${cnpj}`)
      .then((resp) => {
        return resp.data;
      })
      .catch((err) => {
        return null;
      });
  };

  handleOpen = async (cliente) => {
    const cnpj = cliente.UsuarioEmpresa?.Empresa?.cnpj?.replace(/\D/g, '');
    const empresaEnotasPromise = cnpj
      ? this.buscarEmpresaEnotas(cnpj)
      : Promise.resolve(null);

    await this.axios
      .get(`/listarCupomCliente/${cliente.id}`)
      .then((res) => {
        const { data } = res;

        if (data === null) {
          this.setState({ cupom: '' });
        }

        this.setState({ cupom: data });
      })
      .catch((err) => {
        console.log('Error Cupom >>> ', err);
      });

    this.clickAlert();
    if (!cliente.telefone) {
      cliente.telefone = '';
    }
    if (!cliente.rg) {
      cliente.rg = '';
    }
    if (!cliente.cpf) {
      cliente.cpf = '';
    }
    if (cliente.EnderecoUsuario === null) {
      cliente.EnderecoUsuario = this.cleanEnderecoUsuario();
    }
    if (cliente.UsuarioEmpresa === null) {
      cliente.UsuarioEmpresa = this.cleanUsuarioEmpresa();
    }
    if (!cliente.UsuarioEmpresa.Empresa.EmpresaUsuarioNFE) {
      cliente.UsuarioEmpresa.Empresa.EmpresaUsuarioNFE = {};
    }

    const empresaEnotas = await empresaEnotasPromise;
    this.setState({ cliente, empresaEnotas, openModal: true, ready: true });
  };

  handleClose = () => {
    this.clickAlert();
    if (this.state.ready) {
      this.setState({
        cliente: this.cleanCliente(),
        cupom: null,
        empresaEnotas: null,
        openModal: false,
        ready: true,
      });
    } else {
      this.handleAlert(
        true,
        'warning',
        'Aguarde todos dados serem processados!'
      );
    }
  };

  handleSalvar = async () => {
    if (!this.state.isValidPessoal) {
      this.handleAlert(
        true,
        'warning',
        'Preencha todos os dados corretamente!'
      );
      this.setState({ abaModal: 'PESSOAL' });
      return;
    }
    if (
      !this.state.isValidEndreco &&
      this.state.cliente.EnderecoUsuario.cep !== ''
    ) {
      console.log('ENDERECO');
      this.setState({ abaModal: 'ENDERECO' });
      this.handleAlert(
        true,
        'warning',
        'Preencha todos os dados corretamente!'
      );
      return;
    }
    if (
      !this.state.isValidEmpresa &&
      this.state.cliente.UsuarioEmpresa.Empresa.cnpj !== ''
    ) {
      console.log('EMPRESA');
      console.info('aqui > ', this.state.isValidEmpresa);
      console.info('cnpj > ', this.state.cliente.UsuarioEmpresa.Empresa.cnpj);
      this.setState({ abaModal: 'EMPRESA' });
      this.handleAlert(
        true,
        'warning',
        'Preencha todos os dados corretamente!'
      );
      return;
    }

    this.setState({
      msgAlert: 'Aguarde todos dados serem processados!',
      tipoAlert: 'warning',
      openAlert: true,
      ready: false,
      isValidButton: false,
    });
    const erro = [];
    // Checando se atualiza Tem Endereco
    if (this.state.updateEndereco) {
      console.log('Atualizando endereço');
      const endereco = this.state.cliente.EnderecoUsuario;
      endereco.id_usuario = this.state.cliente.id;
      endereco.cep = this.state.cliente.EnderecoUsuario.cep.replace(/\D/g, '');

      await this.axios
        .post(`${environment}/enderecoUsuario`, endereco)
        .then((response) => {
          this.setState({
            ready: true,
            openAlert: true,
            tipoAlert: 'success',
            msgAlert: 'Endereço atualizado com sucesso!',
          });
        })
        .catch((err) => {
          console.log('enderecoUsuario');
          console.log(err);
          erro.push(
            'Erro Ao Cadastrar Endereço do Usuário,Cheque os Dados e tente novamente!'
          );
        });
    }
    // Checando se Tem Empresa
    if (this.state.updateEmpresa) {
      console.log('Atualizando Empresa aqui!');
      const empresa = this.state.cliente.UsuarioEmpresa.Empresa;
      empresa.cnpj = this.state.cliente.UsuarioEmpresa.Empresa.cnpj.replace(
        /\D/g,
        ''
      );
      empresa.cep = this.state.cliente.UsuarioEmpresa.Empresa.cep.replace(
        /\D/g,
        ''
      );
      empresa.id_usuario = this.state.cliente.id;
      empresa.origem = 'portal';
      empresa.vencimento_alvara = empresa.vencimento_alvara
        ? moment(empresa.vencimento_alvara).format('YYYY-MM-DD HH:mm:ss')
        : null;
      empresa.vencimento_bombeiros = empresa.vencimento_bombeiros
        ? moment(empresa.vencimento_bombeiros).format('YYYY-MM-DD HH:mm:ss')
        : null;

      await this.axios
        .post(`${environment}/empresas`, empresa)
        .then((response) => {
          this.setState({
            ready: true,
            openAlert: true,
            tipoAlert: response.data.empresaExisteResponse.empresa.status,
            msgAlert: `Empresa: ${response.data.empresaExisteResponse.empresa.message} | Código HubCount: ${response.data.empresaExisteResponse.hubCount.message} | Empresa Hubcount: ${response.data.empresaExisteResponse.clienteHubcount.message}`,
          });
        })
        .catch((err) => {
          console.log(err);
          erro.push(
            'Erro Ao Cadastrar Empresa,Cheque os Dados e tente novamente!'
          );
        });
    }

    // Checando se Tem Empresa Nfe
    if (this.state.updateNfe) {
      const empresa = this.state.cliente.UsuarioEmpresa.Empresa;
      console.log('Atualizando Empresa Nfe');
      await this.axios
        .post(`${environment}/inserirDadosParaEmissaoNFE`, {
          id: empresa.EmpresaUsuarioNFE.id_enotas,
          id_empresa: empresa.id,
          inscricao_municipal: empresa.EmpresaUsuarioNFE.inscricao_municipal,
          regime_especial_tributacao:
            empresa.EmpresaUsuarioNFE.regime_especial_tributacao,
          descricao_regime_especial_tributacao:
            empresa.EmpresaUsuarioNFE.descricao_regime_especial,
          item_lista_servico: empresa.EmpresaUsuarioNFE.item_lista_servico,
          codigo_servico_municipal:
            empresa.EmpresaUsuarioNFE.codigo_servico_municipal,
          descricao_servico: empresa.EmpresaUsuarioNFE.descricao_servico,
          aliquota_iss: empresa.EmpresaUsuarioNFE.aliquota_iss
            ? empresa.EmpresaUsuarioNFE.aliquota_iss
            : 0,
          numSequencialNF: empresa.EmpresaUsuarioNFE.numero_sequencial_nf
            ? empresa.EmpresaUsuarioNFE.numero_sequencial_nf
            : 1,
          numSerieNF: empresa.EmpresaUsuarioNFE.numero_serie_nf
            ? empresa.EmpresaUsuarioNFE.numero_serie_nf
            : 'UNICA',
          numSequencialLoteNF: empresa.EmpresaUsuarioNFE.numero_sequencial_lote
            ? empresa.EmpresaUsuarioNFE.numero_sequencial_lote
            : 1,
          login_insc_municipal: empresa.EmpresaUsuarioNFE.login_insc_municipal,
          senha_insc_municipal: empresa.EmpresaUsuarioNFE.senha_insc_municipal,
          token: empresa.EmpresaUsuarioNFE.token,
          regime_apuracao_tributos_sn:
            empresa.EmpresaUsuarioNFE.regime_apuracao_tributos_sn,
          codigo_tributacao_nacional:
            empresa.EmpresaUsuarioNFE.codigo_tributacao_nacional,
          codigo_nbs: empresa.EmpresaUsuarioNFE.codigo_nbs,
          classificacao_tributaria:
            empresa.EmpresaUsuarioNFE.classificacao_tributaria,
          situacao_tributaria: empresa.EmpresaUsuarioNFE.situacao_tributaria,
          codigo_indicador_operacao:
            empresa.EmpresaUsuarioNFE.codigo_indicador_operacao,
          percentual_aproximado_tributos_sn:
            empresa.EmpresaUsuarioNFE.percentual_aproximado_tributos_sn,
        })
        .then((response) => {
          this.setState({
            ready: true,
            openAlert: true,
            tipoAlert: 'success',
            msgAlert: 'Empresa NFE atualizado com sucesso!',
          });
        })
        .catch((err) => {
          console.log('EmissaoNFE');
          console.log(err);
          let msgError = '';

          if (err.response) {
            msgError =
              err.response.data || err.response.data
                ? err.response.data.message
                : 'Erro Ao Cadastrar dados Nota Fiscal,Cheque os Dados e tente novamente!';
          } else {
            msgError =
              'Erro Ao Cadastrar dados Nota Fiscal,Cheque os Dados e tente novamente!';
          }
          this.setState({
            msgAlert: msgError,
            tipoAlert: 'warning',
            openAlert: true,
          });
          erro.push(msgError);
        });
    }

    if (this.state.updateUser) {
      console.log('Atualizando Dados Pessoais');
      // Atualizando Dados Pessoais
      const cliente = {
        telefone: this.state.cliente.telefone.replace(/\D/g, ''),
        nome: this.state.cliente.nome,
        sexo: this.state.sexo,
        nome_mae: this.state.cliente.nome_mae,
        rg: this.state.cliente.rg,
        perfil: this.state.cliente.perfil,
        id_segmento_atuacao: this.state.cliente.id_segmento_atuacao,
        ativo: this.state.cliente.ativo,
        relogar: 1,
      };

      await this.axios
        .post(`${environment}/cliente/${this.state.cliente.id}`, cliente)
        .then((response) => {
          this.setState({
            ready: true,
            openAlert: true,
            tipoAlert: 'success',
            msgAlert: 'Dados pessoais atualizado com sucesso!',
          });
        })
        .catch((err) => {
          console.log('cliente');
          console.log(err);
          erro.push(
            'Erro Ao Cadastrar Cliente,Cheque os Dados e tente novamente!'
          );
        });
    }

    console.log('Fim!!!');
    this.setState({
      ready: true,
      updateUser: erro.length ? this.state.updateUser : false,
      updateEndereco: erro.length ? this.state.updateEndereco : false,
      updateEmpresa: erro.length ? this.state.updateEmpresa : false,
      updateNfe: erro.length ? this.state.updateNfe : false,
      isValidButton: true,
      openAlert: true,
      openModal: !!erro.length,
      // tipoAlert: erro.length ? 'error' : 'success',
      // msgAlert: erro.length ? erro.toString() : 'Atualizado com sucesso!',
      busca: '',
    });

    if (!erro.length) {
      this.atualizarClientes(
        '',
        10,
        0,
        false,
        this.state.idOrder,
        this.state.order
      );
    }
  };

  handleChangePerfil = () => {
    const cl = this.state.cliente;
    if (cl.perfil === 'ADMIN') cl.perfil = 'COMUM';
    else cl.perfil = 'ADMIN';
    this.setState({ cliente: cl });
  };

  handleUpdateClient = (obj, isValid) => {
    this.setState({ cliente: obj, isValidPessoal: isValid, updateUser: true });
  };

  handleUpdateEndereco = (endereco, isValid) => {
    const obj = this.state.cliente;
    obj.EnderecoUsuario = endereco;
    this.setState({
      cliente: obj,
      isValidEndreco: isValid,
      updateEndereco: true,
    });
  };

  handleUpdateEmpresa = (empresa, isValid) => {
    const obj = this.state.cliente;

    obj.UsuarioEmpresa.Empresa = empresa;
    this.setState({
      cliente: obj,
      isValidEmpresa: isValid,
      updateEmpresa: true,
    });
  };

  handleUpdateEmpresaNfe = (empresa, isValid) => {
    const obj = this.state.cliente;
    obj.UsuarioEmpresa.Empresa.EmpresaUsuarioNFE = empresa;
    this.setState({ cliente: obj });
    this.setState({ updateNfe: isValid });
  };

  openModal = (event, columnid) => {
    this.setState({ filterText: '' });
    const rect = event.target.getBoundingClientRect();
    this.setState({
      isModalOpen: true,
      modalPosition: { top: rect.bottom, left: rect.left },
      modalColumnId: columnid,
    });
  };

  handleFilterTextChange = (event) => {
    this.setState({ filterText: event.target.value });
  };

  // Function to filter the table data
  filterTable = () => {
    this.setState({ isModalOpen: false });
    const { clientes, filterText, modalColumnId } = this.state;
    const filteredDas = clientes.filter((item) => {
      const value = this.getValueColumnId(modalColumnId, item);
      return (
        value &&
        value.toString().toLowerCase().includes(filterText.toLowerCase())
      );
    });
    // Update the table data with filtered data
    this.setState({ clientes: filteredDas });
  };

  getValueColumnId(columnId, rowData) {
    columnId = columnId.replace(/"/g, '');
    console.log(columnId);
    const parts = columnId.split('.');
    console.log(rowData);
    console.log(parts);
    let result = null;
    for (let part of parts) {
      if (result === null) {
        // If result is null, assign the global object to result
        result = rowData[part];
      } else {
        // If result is not null, access the property
        result = result[part];
      }
    }
    console.log(result);
    return result;
  }
  clearFilter = () => {
    this.setState({ isModalOpen: false });
    this.setState({ filterText: '', clientes: this.state.originalClientes });
  };

  closeModal = () => {
    this.setState({ isModalOpen: false });
  };

  handleRequestSort = (property) => {
    const orderBy = property;
    let order = 'desc';

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    this.setState({ order, orderBy });
  };

  sortTable = (property) => {
    const { clientes, order } = this.state;
    console.log(property);
    const isAsc = order === 'asc';
    clientes.sort((a, b) => {
      let aValue = this.getValueColumnId(property, a);
      let bValue = this.getValueColumnId(property, b);
      // If the property is a string, convert to lowercase for case-insensitive sorting
      if (typeof aValue === 'string') {
        aValue = aValue.toLowerCase();
        bValue = bValue.toLowerCase();
      }
      if (aValue < bValue) {
        return isAsc ? -1 : 1;
      }
      if (aValue > bValue) {
        return isAsc ? 1 : -1;
      }
      return 0;
    });
    this.setState({ clientes });
  };
  render() {
    const { classes } = this.props;
    const TelefonePattern = ['(99)99999-9999'];
    const CPFPattern = ['999.999.999-99'];
    const CNPJPattern = ['99.999.999/9999-99'];

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          paddingTop: 20,
        }}
      >
        <Modal
          open={this.state.isModalOpen}
          onClose={this.closeModal}
          style={{
            top: this.state.modalPosition.top,
            left: this.state.modalPosition.left,
          }}
        >
          <div
            style={{
              backgroundColor: 'white',
              padding: '20px',
              borderRadius: '5px',
              width: '300px',
            }}
          >
            <TextField
              label="Filtrar"
              variant="outlined"
              value={this.state.filterText}
              onChange={this.handleFilterTextChange}
              fullWidth
            />
            <Button
              variant="contained"
              color="primary"
              onClick={this.filterTable}
              style={{ marginTop: '10px' }}
            >
              Filtrar
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={this.clearFilter}
              style={{ marginTop: '10px', marginLeft: '5px', width: 70 }}
            >
              Limpar
            </Button>
          </div>
        </Modal>
        <Snackbar
          open={this.state.openAlert}
          autoHideDuration={18000}
          onClose={this.clickAlert}
        >
          <Alert severity={this.state.tipoAlert} onClick={this.clickAlert}>
            {this.state.msgAlert}
          </Alert>
        </Snackbar>
        <h1>Clientes</h1>
        <Paper className={classes.root}>
          <Collapse in={this.state.ready}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                padding: 10,
              }}
            >
              <FormGroup>
                <FormControlLabel
                  control={
                    <Switch
                      checked={this.state.assinantes}
                      onChange={this.handleAssinantes}
                      color="primary"
                    />
                  }
                  label={this.state.textoSwitch}
                />
              </FormGroup>
              <TextField
                id="busca"
                label="Busca"
                value={this.state.busca}
                onChange={this.handleBusca}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {this.state.columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                      sortDirection={
                        this.state.orderBy === column.id
                          ? this.state.order
                          : false
                      }
                    >
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <TableSortLabel
                          active={this.state.orderBy === column.id}
                          direction={
                            this.state.orderBy === column.id
                              ? this.state.order
                              : 'asc'
                          }
                          onClick={() => {
                            this.handleRequestSort(column.id);
                            setTimeout(() => {
                              this.sortTable(column.id);
                            }, 200);
                          }}
                        >
                          {column.label}
                        </TableSortLabel>

                        {column.filterable && (
                          <IconButton
                            style={{ marginLeft: -5 }}
                            onClick={(event) =>
                              this.openModal(event, column.id)
                            }
                            aria-label="filtra"
                          >
                            <FilterIcon style={{ width: 16, height: 16 }} />
                          </IconButton>
                        )}
                      </div>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.clientes.map((c) => {
                  const estilo = c.ativo ? {} : { color: '#DC143C' };
                  const cidade = c.EnderecoUsuario
                    ? c.EnderecoUsuario.cidade
                    : '';
                  const estado = c.EnderecoUsuario
                    ? c.EnderecoUsuario.estado
                    : '';
                  const cnpj = c.UsuarioEmpresa
                    ? mask(c.UsuarioEmpresa.Empresa.cnpj, CNPJPattern)
                    : '';
                  const cpf = c.cpf ? mask(c.cpf, CPFPattern) : '';
                  const telefone = c.telefone
                    ? mask(c.telefone, TelefonePattern)
                    : '';

                  return (
                    <TableRow key={c.id}>
                      <TableCell component="th" scope="row" style={estilo}>
                        {c.nome}
                      </TableCell>
                      <TableCell component="th" scope="row" style={estilo}>
                        {cpf}
                      </TableCell>
                      <TableCell component="th" scope="row" style={estilo}>
                        {cnpj}
                      </TableCell>
                      <TableCell component="th" scope="row" style={estilo}>
                        {cidade}
                      </TableCell>
                      <TableCell component="th" scope="row" style={estilo}>
                        {estado}
                      </TableCell>
                      <TableCell component="th" scope="row" style={estilo}>
                        {c.email}
                      </TableCell>
                      <TableCell component="th" scope="row" style={estilo}>
                        {telefone}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <IconButton
                          onClick={() => this.handleOpen(c)}
                          style={{
                            color: XMEI_PRIMARY_COLOR,
                          }}
                          aria-label="Editar Clientes"
                        >
                          <EditIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={this.state.count}
              rowsPerPage={this.state.limit}
              page={this.state.offset}
              onChangePage={this.handleChangePage}
              onChangeRowsPerPage={this.handleChangeRowsPerPage}
            />
          </Collapse>
          <Collapse in={this.state.ready === false}>
            <div align="center">
              <CircularProgress />
            </div>
          </Collapse>
        </Paper>
        <Modal open={this.state.openModal} onClose={this.handleClose}>
          <Grid container spacing={3} className={classes.paper}>
            <h2>Dados do Cliente</h2>
            <Grid item xs={12}>
              <ButtonGroup
                fullWidth
                color="primary"
                aria-label="outlined primary button group"
              >
                <Button
                  onClick={() => {
                    this.setState({ abaModal: 'PESSOAL' });
                  }}
                  disabled={!this.state.ready}
                  color={
                    this.state.abaModal === 'PESSOAL' ? 'secondary' : 'primary'
                  }
                >
                  Pessoal
                </Button>
                <Button
                  onClick={() => {
                    this.setState({ abaModal: 'ENDERECO' });
                  }}
                  disabled={!this.state.ready}
                  color={
                    this.state.abaModal === 'ENDERECO' ? 'secondary' : 'primary'
                  }
                >
                  Endereço
                </Button>
                <Button
                  onClick={() => {
                    this.setState({ abaModal: 'EMPRESA' });
                  }}
                  disabled={!this.state.ready}
                  color={
                    this.state.abaModal === 'EMPRESA' ? 'secondary' : 'primary'
                  }
                >
                  Empresa
                </Button>
                {this.state.cliente.UsuarioEmpresa.Empresa.cnpj ? (
                  <Button
                    onClick={() => {
                      this.setState({ abaModal: 'NOTAFISCAL' });
                    }}
                    disabled={!this.state.ready}
                    color={
                      this.state.abaModal === 'NOTAFISCAL'
                        ? 'secondary'
                        : 'primary'
                    }
                  >
                    Nota Fiscal
                  </Button>
                ) : null}
              </ButtonGroup>
            </Grid>
            <Grid item xs={12}>
              <Collapse in={this.state.abaModal === 'NOTAFISCAL'}>
                <NotaFiscal
                  empresa={this.state.cliente.UsuarioEmpresa.Empresa}
                  empresaEnotas={this.state.empresaEnotas}
                  handleUpdateEmpresaNfe={this.handleUpdateEmpresaNfe}
                />
              </Collapse>
              <Collapse in={this.state.abaModal === 'ENDERECO'}>
                <Endereco
                  endereco={this.state.cliente.EnderecoUsuario}
                  handleUpdateEndereco={this.handleUpdateEndereco}
                  handleChangeCepCliente={this.handleChangeCepCliente}
                  handleAlert={this.handleAlert}
                />
              </Collapse>
              <Collapse in={this.state.abaModal === 'PESSOAL'}>
                <Pessoal
                  cliente={this.state.cliente}
                  handleUpdateClient={this.handleUpdateClient}
                />
              </Collapse>
              <Collapse in={this.state.abaModal === 'EMPRESA'}>
                <Empresa
                  empresa={this.state.cliente.UsuarioEmpresa.Empresa}
                  cupom={this.state.cupom}
                  cliente={this.state.cliente}
                  handleUpdateEmpresa={this.handleUpdateEmpresa}
                  cpf={this.state.cliente.cpf}
                  handleAlert={this.handleAlert}
                />
              </Collapse>
              <Grid container spacing={3} style={{ paddingTop: '5%' }}>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={this.state.cliente.perfil === 'ADMIN'}
                        onChange={this.handleChangePerfil}
                        name="checkPerfilInterno"
                        color="primary"
                      />
                    }
                    label="Interno"
                  />
                </Grid>
                <Grid item xs={6}>
                  <Collapse in={this.state.cliente.ativo}>
                    <Button
                      variant="contained"
                      color="secondary"
                      startIcon={<DeleteIcon />}
                      onClick={this.handleAtivarDesativar}
                      disabled={!this.state.isValidButton}
                    >
                      Desativar
                    </Button>
                  </Collapse>
                  <Collapse in={!this.state.cliente.ativo}>
                    <Button
                      variant="contained"
                      color="primary"
                      startIcon={<CheckIcon />}
                      onClick={this.handleAtivarDesativar}
                      disabled={!this.state.isValidButton}
                    >
                      Ativar
                    </Button>
                  </Collapse>
                </Grid>
                <Grid item xs={6}>
                  <div align="right">
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={this.handleSalvar}
                      startIcon={<SaveIcon />}
                      disabled={!this.state.isValidButton}
                    >
                      Salvar
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Modal>
      </div>
    );
  }
}

export default withStyles(useStyles)(ClientesComponent);
